// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__FsCPd","client-logo":"MainNavigation_client-logo__oYjb5","wallet-button":"MainNavigation_wallet-button__CtTxR"};